export var size25 = "4px";
export var size50 = "8px";
export var size75 = "12px";
export var size100 = "16px";
export var size200 = "24px";
export var size300 = "32px";
export var size375 = "44px";
export var size400 = "48px";
export var size500 = "64px";
export var size600 = "128px";
export var size700 = "256px";
export var size750 = "384px";
export var size800 = "512px";
export var size850 = "768px";
export var size900 = "1024px";